module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-num",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1")])]), _vm._v(" "), _c('h2', {
    staticClass: "chap-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Atatürk’s “Üniversite Reformu”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“In its essence, the affair that we call or understand as the Atatürk Üniversite Reformu was not a mere university reform, but the ultimate apex of the Atatürk cultural movement started in the years 1925 to 1926.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn1",
      "id": "rch1fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before the early part of the nineteenth century, the Ottoman state never accepted responsibility for the basic education of its citizens or subjects. Hence, no formal system of public education then existed. The state trained some of its military and bureaucratic officials; the clergy instructed some of its own future members; but the education of non-official, non-clerical subjects was not conceived as a public responsibility. The process of ‘modernization’ in education involved the gradual and grudging acceptance of this responsibility by the Ottoman state."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn2",
      "id": "rch1fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Until the 17"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" century, the Ottoman Empire was one of the most powerful countries in the world. Then it dramatically lost status as well as power because it did not keep up with, or better, Europe’s scientific and technological gains, especially during the 18"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" century. Development of the Empire’s army was the top priority. To achieve this goal, many French officers were brought in to aid the Ottoman modernization. For a long time, the Empire continued to benefit from importing officers, experts, and scientists, mostly from Europe and mostly for its army."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn3",
      "id": "rch1fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Officers from Europe were used in its new military schools. In 1735, a new artillery school was established by Sultan Mahmud I, and Alexander Comte de Bonneval from France was named administrator. Some forty years later, in 1773, under Ottoman Sultan Mustafa III, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Muhendishane-i Bahr-i Humayun,")]), _vm._v(" the Royal School of Naval Engineering, was established to educate chart masters and shipbuilders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the Royal School’s formative years, it was supervised by Baron de Tott, a French expatriate military officer. Furthermore, in 1795 "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("bearing the same name "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Muhendishane-i Berr-i Humayun,")]), _vm._v(" the Royal School of Military Engineering, was established to educate technical support personnel. In addition to Baron de Tott, many others were brought in from foreign countries to modernize the army and to teach at those schools. Among these were Englishman Kampell Mustafa, a convert to Islam, a Frenchman named Le Roi et du Reste (naval engineering), Major Lafitte Clavet and a Captain Monier (military and civil engineering), Francois Petolin (cannon testing), Captain Saint-Remy (artillery), and an officer named Tondul (astronomy)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn4",
      "id": "rch1fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Sisman,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn5",
      "id": "rch1fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" over a century after the Ottomans westernized education of their military officer corps and following the Reform Edict of 1856, individual students were sent to Europe and to France, in particular, for further education while “a school known as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mekteb-i Sultani")]), _vm._v(" opened in Paris.” At the same time, secondary schools providing a “modern” education were being created within the Empire. Of these, the most important was the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Galatasaray Mekteb-i Sultanisi,")]), _vm._v(" later known as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Galatasaray Lycee."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn6",
      "id": "rch1fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" In many studies, “this school, has been described as the first window opened on to the West.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Additionally Turkish secondary education was affected by the telegraph. In 1861, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Funu-i Telgrafiye Mektebi")]), _vm._v(" (School of Telegraphic Science) was established. It offered a two-year program for technical education in all aspects of telegraphy."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn7",
      "id": "rch1fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Later, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Galatasaray,")]), _vm._v(" a high school for the poor and orphans, launched courses in telegraphy. Between 1869 and 1923, a number of vocational “Technical Schools” were opened. Among these were a School of Finance (1876), a Civil Medical School (1877), School of Law (1878), School of Commerce (1882), a Civil Veterinary School (1889), a School for Vaccinators (1894), the Finance Officials School (1910), the Tax Collectors School (1911), and a Railroad Officials School opened in (1915)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn8",
      "id": "rch1fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" None of these was considered to be of university caliber except for the Dar-ül Fünun. The Dar-ül Fünun, built by the Swiss architect Gaspare Fossati in 1854, became the first Ottoman University via a 1919 ordinance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Dar-ül Fünun went through three major reforms. In its transformation from a major "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("madrasa,")]), _vm._v(" it became a secular university circa 1900; in 1915, its second reform, German academics were brought by the Ottoman Government to upgrade several academic disciplines. Among those invited was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fritz Arndt")]), _vm._v(" and two other German chemists. This trio helped to establish the first chemistry department in Turkey. Its curriculum was based on the prevailing German model. However, because the Dar-ül fünun was an Ottoman University, many of its other curricula continued to have a Moslem orientation. Dar-ül Fünun’s third reform took place in 1933 and created the basis for this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It all began in 1924. Atatürk, now firmly in power, obliterated the "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("existing system of religious education. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("madrasas")]), _vm._v(" and all other religious schools maintained by the religious establishment were taken over by the now-secularized Ministry of Education. For centuries, these schools had been responsible for maintaining traditionalism. This was antithetic to the new regime. Consequently, the State under Atatürk assumed the responsibility of educating its citizens at all levels. In 1924, the government launched a process of expanding and improving the existing structure of secular public schools.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On July 31 1933, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dar-ül Fünun")]), _vm._v(" was officially closed by government decree, as a means of canceling all existing good-for-life faculty contracts."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn9",
      "id": "rch1fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" The very next day, the Istanbul University was opened using "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dar-ül Fünun")]), _vm._v("’s physical plant, a small fraction of the original faculty, and more than thirty world-renowned émigré German professors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each professor signed some variation of a formal contract similar to the one given to and signed by pediatrician Albert Eckstein:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Ministry of Health and Social Assistance has appointed Prof. Eckstein as the Director of the Pediatrics Service of the Ankara Nümune Hospital. He should consecrate all his activities to the medical and scientific requirements of the clinical services and the laboratory work attached to his specialty. He is expected to develop the knowledge of the doctors and the assistants and to contribute to the education of the students when necessary. He is also bound to report his thoughts about the scientific matters pertaining to his specialty as requested by the Ministry and to publish articles prepared according to the usual practices of the scientific circles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The duration of this contract is 5 years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This contract may be renewed for 3-5 years on the wishes of both parties.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The salary is 750 Turkish liras"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn10",
      "id": "rch1fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" net after all taxes and fees are deducted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prof. Eckstein may take out with him all the savings from his salary when he leaves Turkey with the permission of the public office he works for.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He will be paid 250 Turkish liras for himself, his wife and his children aged over 10 years and 125 Turkish liras for each child aged less than 10 as relocation expenses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He will be granted six weeks paid leave every year. He can travel wherever he wishes but will not be paid travel expenses for these trips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He will be compensated according to the same rules for civil "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("servants of high grade whenever he is asked to travel by the government.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This contract may only be annulled by the consent of both parties due to inevitable causes. Full salary is paid for the first three months in case of sickness. After three years of service, the total amount corresponding up to 6-months salary will be paid for each year. Dr. Eckstein accepts to submit a medical report on his health prepared by an official doctor. In case of death, an amount of 1000 Turkish liras as well as six months’ salary will be paid to his widowed wife or to his children in the absence of a wife.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prof. Eckstein cannot practice medicine privately outside the Ankara Nümune Hospital, nor can he open an office. In exceptional cases, if he is invited for consultation by Turkish doctors and his opinion is requested on the case under consultation, he may accept the invitation and submit his opinion on the case, provided it does not take the form of private medical practice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prof. Eckstein does not have the right to demand any compensation whatsoever in return for the medical and surgical care he provides for the non-paying and paying patients admitted to the hospital or examined in the polyclinic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This contract enters in force the day it is signed by both parties. His salary will begin to be paid when he starts working in Ankara.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Contracts were signed every year. Most of the senior faculty were given the title Ordinarius Professor or “Ord. Prof.” for short. It corresponds to the German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Auserordentlicher")]), _vm._v(" (extraordinary) professor. In America, there is no fully equivalent title. The closest might be Distinguished or Chaired professor except the latter usually carries an endowment from some individual’s, family’s, company’s, or foundation’s financing, generally good for the professor’s lifetime. The latter was not at all the case with the Ordinarius appointments in Turkey. In fact, all contracts albeit renewable were for fixed terms and did not include pension rights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1933, distinguished American mathematician, professor Richard Courant and Nobel Laureate in Physics James Franck were asked by the American Rockefeller Foundation to assess the state of Istanbul University. On October 25, Courant filed their joint report. Courant and Franck noted that they had found “a decided wish [among the officials] to create a promising scientific center in Istanbul, which should contribute to the development of higher education in Turkey. The earnest wish to reconstruct [to change] existing conditions was repeatedly expressed in conversations with the Minister, other officials and private individuals as well as in the press.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn11",
      "id": "rch1fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("At the same time, the Americans were shocked at prevailing conditions, writing that the state “of the so-called university organizations in Istanbul is so miserable that for the present there can be no question for the next few years of a university life modeled on European lines, especially since the [available] Turkish material in students and assistants probably is not yet sufficiently trained for a true cultivation of the sciences.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One particular barrier to progress they saw was that “between students and foreign professors considerable difficulty would exist at the beginning owing to language.” There were some areas—they noted geography and chemistry—in which the starting point would be better because European professors had made previous progress (during Dar-ül Fünun’s 1915 reform), and they found the clinics also promising. But, “in the field of physics and mathematics, there are, however, almost no practical preparations. They [the Turks] lack institutes, equipment, apparatus, and library. The acquisition of all these things will require much organizing power on the part of the professors in question.” Courant goes on to say:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We had the impression that out of a certain ignorance the Turks underestimate these problems and are of the opinion that merely adding a line-up of recognized scholars, would be sufficient to start up a real university. Although by doing so we somewhat offended their prestige requirement, we advised them to recruit primarily younger workers for mathematics and the natural sciences and occasionally bring in older scientists like Frank [sic] for a limited time as guests and liaisons with European science.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("History shows that the Turks did not follow the above advice. The overall assessment by Courant and Franck however was optimistic:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Our whole impression is that if general conditions remain as they are in Turkey, a promising career for science can spring up in Turkey, that the enterprise promises to be profitable to the country, and that in our fields after a certain preparatory period, scientific research will also be possible."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn12",
      "id": "rch1fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moreover, on December 8 1933, Arnold Knapp, M.D. of New York wrote to Dr. Alan Gregg of the Rockefeller Foundation: “Prof. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Joseph Igersheimer,")]), _vm._v(" of Frankfort, Germany, is now taking charge of the Eye Clinic at the University of Istanbul. He writes me that conditions are very primitive there, and all opportunities for doing research work are very meager, principally on account of lack of funds.... The Professor is one of the eminent younger ophthalmologists of Germany.... He was one of three "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("men selected to report on tuberculous eye diseases at the International Ophthalmological Congress, in Madrid.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn13",
      "id": "rch1fn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0024-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("New professors of the University:")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("New professors invited from Europe to teach at the University have started to arrive in Istanbul. Professor Hirsch who will teach Trade Law at the Law Faculty arrived the day before at the university where he had talks with the dean and his colleagues. He stated that he will reside in a Turkish milieu in Istanbul so that he can learn Turkish within three years and that he considered Turkey as his own country. All the foreign professors will be at their posts by 25"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" of October. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Le Journal d’Orient, October 20 1933.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just a couple of decades after the Ottoman Empire had taken its last breath, the general exodus had so depleted Germany’s premier higherlearning institutions of professors that the University of Istanbul was rightfully considered and sincerely called “the best German University in the world.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn14",
      "id": "rch1fn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" According to Onur Öymen, a 2003 Member of Turkey’s Parliament, the Turkish government’s contracts with the émigré professors set salaries “well exceeding” those of the Turkish professors. Öymen "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("pointed out that “the purpose of the Turkish government was to upgrade the academic level of Istanbul University to that of western European universities.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn15",
      "id": "rch1fn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By October 19 1933, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dr. R. A. Lambert,")]), _vm._v(" Associate Director of Rockefeller Foundation’s European Office, wrote to his friend Dr. Lorrin Sheppard, the resident Director of Istanbul’s American Hospital, in disbelief: “I got the impression from some of the recent visitors that the new developments represented a more sweeping change than I understood to be the case. I share your hope that the splendid effort the Turks are making in the field of education will have the fullest success.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn16",
      "id": "rch1fn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Almost incredibly, courses began on November 5 1933 as reported in various media including Istanbul’s French language, newspaper, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Le Journal d’Orient.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just ten years later, sufficiently impressed with the undergraduate education provided by Istanbul University, Harvard’s Medical School admitted Lahut Uzman, one of Istanbul’s undergraduates, to study medicine."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn17",
      "id": "rch1fn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Eugen Merzbacher, also a 1943 graduate from the University of Istanbul, was admitted to Harvard’s school of graduate studies where he earned an M.A. and a Ph.D. in physics."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn18",
      "id": "rch1fn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Moreover, on arrival in the United States before, during, and shortly after WWII, several engineering graduates of Istanbul Technical University, which had also been significantly upgraded by émigré professors, had their educational credentials recognized by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York State Registration Board for Civil and Professional Engineers")]), _vm._v(" for purposes of licensing."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn19",
      "id": "rch1fn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was not only undergraduate degrees from Istanbul University that were being recognized by top-notch American universities. Elizabeth S. [Sgalitzer] Ettinghausen, a 1943 Ph.D. recipient in history of art and archaeology from Istanbul University, received Post-doctoral fellowships from Harvard University (1943-45) for research in Byzantine churches of Istanbul. Princeton later awarded her a post-doctoral degree as well."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn20",
      "id": "rch1fn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" At the same time, [Turkish] graduates of émigré-founded Ankara State Conservatory came to be recognized by playing to critical audiences worldwide. They included violinists such as Ayla Erduran (Suisse Romande Orchestra, Warsaw Philharmonic, Paris Conservatory, and Moscow Conservatory, and others) and Suna Kan (London Symphony, the Los Angeles Philharmonic, Bamberg Symphony, Residentie Orchestra (Holland), Moscow Symphony, and French National Radio Symphony {ORTF} among others).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With less world acclaim, but nonetheless filling a great need, the early graduates of Ankara University’s medical school became Turkey’s most revered practitioners and professors. One of these is retired Professor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Behçet Tahsin Kamay.")]), _vm._v(" In discussing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Albert Eckstein,")]), _vm._v(" one of his own mentors, émigré pediatrics professor Kamay said:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("He reached the remotest corners of Anatolia [Asia Minor part of Turkey] and he walked over every inch of the land. He visited the villages and went among the villagers; he knocked on their doors and became their guest. He was a doctor of the people and a Turkophile; in every place he visited, he ate the peasants’ food, drank their buttermilk, and learned their health and social problems.... He had the courage to tell of both the diseases [he encountered] and the treatments [prescribed] to his students, the university circles, and state [provincial] and government officials through his writings, lectures, and conferences."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn21",
      "id": "rch1fn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Similarly, Dr. Mustaffer Sertabiboglu, recalled: “I am one of the first graduates of the Ankara Medical Faculty. My diploma has the number 68 on it. I am one of those who was nourished by the wisdom of [Albert] Eckstein.” Sertabiboglu was referring to émigré pediatrican "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Albert Eckstein")]), _vm._v(" who introduced modern public-health and pediatrics practices to Turkey. He continued by pointing out one element of Eckstein’s success: “[He] considered Turkey as his second home and was able to lecture without translators by learning Turkish in a short time.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn22",
      "id": "rch1fn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Professors Behçet Tahsin Kamay and Mustaffer Sertabiboglu both referred to Albert Eckstein as their "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hoca—an")]), _vm._v(" affectionate old Turkish term for the “Teacher” with a capital “T.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The distribution of the European professors was not equal among the four Faculties, or what we call colleges or schools. The vast majority of émigré professors were in medicine and the Faculty devoted to mathematics and natural science. There were fewer émigrés in the Faculties of law and the arts. But academics of great renown were to be found in all of these administrative units. Dr. Lambert, who was sent from Paris to Turkey, entered the following observation in his diary of February 18 1934.")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The state of the science departments is much like that of medicine, namely, activity and disorder, inevitable in the task of hasty reorganization. We find [physics] Prof. von Hippel trying to teach, through an interpreter, a group of interested students; he looks happy. Freundlich, [astronomy] on the contrary, looks worried and raises immediately the question of RF [Rockefeller Foundation] aid for an observatory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have a short talk with [surgery] Prof. Rud[olf]. Nissen while he is scrubbing up for an operation. He is a young, energetic man who, like Schwarz, has jumped into the work immediately. There is, I am told, considerable criticism, of the new clinicians by the displaced Turks, but, as S. [Schwarz] points out, it is remarkable "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("that the native professors should have accepted the situation as gracefully as they have."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn23",
      "id": "rch1fn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fewer of the academics found their way to Ankara than to Istanbul. This was due mainly to the infrastructure of the University of Ankara at the time. The university was still in the planning stages and mainly existed on paper. It was still mostly undeveloped land. Only a few institutes and scientific organizations were functioning. The disciplinary borderlines were not as clearly defined in Ankara as they were in Istanbul. Unlike those who came to the University of Istanbul under "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notgemeinschaft’s")]), _vm._v(" auspices, most of the scientists, architects, and artists who went to Ankara were invited through the official German and Austrian legations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The largest share of émigrés in Ankara was to be found in the State school of music and the next largest was in the Faculty of Arts and the medical institutes. From a merely external point of view, achievements of the emigrants in Ankara can best be measured by the impressive buildings designed by Clemens Holzmeister and his colleagues and by the reputation of the state’s orchestra and school of opera founded by Paul Hindemith and his colleagues."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn24",
      "id": "rch1fn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This all happened because in 1931 Atatürk had commissioned a study of the concept of creating a completely modern system of higher education modeled on West European universities. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rapport sur l’universite’ d’Istanbul")]), _vm._v(" by Swiss educationalist Albert Malche was submitted in 1932. And, in the next year, an internal Rockefeller Foundation memorandum states: “The new developments in Turkey should be followed closely and sympathetically. The transplantation of so many eminent German scholars in Istanbul cannot but have far-reaching repercussions. The present transformation of Turkey offers so many problems of economic, social and political significance as to provide a fruitful field of research.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn25",
      "id": "rch1fn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two years later, the Rockefeller Foundation sent Dr. R. A. Lambert back to Istanbul for a first-hand assessment of the situation. In Lambert’s diary, an entry dated Friday, February 16 1934, recognizes that “[T]here is no doubt that Mustapha Kemal [Atatürk] and his Ministers of Hygiene and Education are determined to have in Istanbul, in the shortest possible time, a first class University with a Med. School that will command the respect of the West. Ankara is also to have a university, with later on a Med. Faculty. Agricultural institutes, including veterinary medicine, have already been established there.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn26",
      "id": "rch1fn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus, in scarcely more than a decade, Turkey was well on its way to having upgraded and modernized all the major basic and practical sciences, and to having made its distinctive mark in western classical music.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appendix 1 of this book shows the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("history")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mission")]), _vm._v(" statements as "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("posted on the web by the original three Turkish universities in their own words. Each of the three contemporary statements independently attests to the national pride in the legacy that was left behind by the émigré professors. Each independently attests to the social groupings created by that legacy, and recognizes the effect that these groupings continue to have on Turkish higher education and on society at large.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Through Atatürk’s “leadership qualities and position,” a government policy was institutionalized and simultaneously so was the “enduring nature of cultural values.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn27",
      "id": "rch1fn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" To appreciate the achievements praised in the contemporary statements that are cited above, it is necessary to go back to the 1933-1934 academic year when the exiled professors from Germany"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn28",
      "id": "rch1fn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" first served as directors in eight of the twelve basic science institutes as well as heading six of the seventeen clinics in the Faculty of Medicine. And the conditions were far from ideal. According to reports submitted in the fall of 1933 by Professor Philipp Schwarz, the new Director of the Institute of Pathology, the entire Faculty of Medicine experienced scarcities of equipment and buildings. There were only thirty extremely old microscopes for all seven basic science disciplines. The clinics were in bad shape, neglected, and under-equipped."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn29",
      "id": "rch1fn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" In order to overcome difficulties, the émigré professors used every bit of ingenuity God had given them. They went to the local bazaars and had merchants find for them pieces and parts of equipment from sources unknown. They pleaded for institutional donations from abroad, and the Rockefeller Foundation responded. Harvard and Yale sent back-issues of their journals for library research. The “Germans” overcame most if not all obstacles, including the ones put in their way by Turks they had dispossessed, or somehow offended, and who were not about to let this transition be easy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In order to facilitate the Ottomans’ descendants’ progress in modern science and medicine, and to satisfy terms of their contracts, the émigré professors were obligated to write Turkish language textbooks in their respective subjects. To do so often required invention of new words and new alphaneumeric symbols and acronyms. The words had to reflect Turkish roots. The symbols would follow. However, they needed to reflect all that was inherited over centuries in the Arabic alphabet. For the German-speaking émigrés who knew no Turkish, this was a daunting task indeed. With Turkish colleagues as wingmates, many of the émigrés stood up to the challenge. Many textbooks resulted and were published.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some seventy years later, retired professor and chair of Istanbul University’s Chemical Engineering Department, Professor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("İsmet Gürgey,")]), _vm._v(" took issue with a speech that was published in the 200th issue of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Çağda")]), _vm._v("ş "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Türk Dili Dergisi (The Journal of Contemporary Turkish Language)")]), _vm._v(" celebrating the Turkish Language Reform’s 72nd anniversary. The speaker was "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("distinguished Professor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tahsin Yücel.")]), _vm._v(" Yücel, according to Gürgey, had ignored the major contributions made to Turkish sciences by the émigré, Professor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fritz Arndt."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn30",
      "id": "rch1fn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Significantly, Gürgey claimed that Yücel’s article ignored the important contributions Arndt and other scientists had made to development of the Turkish language and its scientific nomenclature. Listed at the end of Yücel’s speech, Gürgey says, “are the names of scientists, writers, and poets who have contributed to the purification and development of our language.” Gürgey takes especial umbrage with Yücel’s list of scientists and writers “who have contributed to the purification and development of our language.” He claimed that the names were drawn from somewhat limited circles, all but ignoring these pioneers, Turkish and European, from the 30s. Gürgey writes, “I asked myself whether the improvement of Turkish within the passage of time was only due to efforts of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Turkish Language Association,")]), _vm._v(" the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Language Society,")]), _vm._v(" the linguists and the poets.” “[S]hould not others such as Prof. Dr. Oktay Sinanoglu, Prof. Dr. Enver Altinli, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ord. Prof. Fritz Arndt")]), _vm._v(" of indisputable reputation in the sciences, and proponents of Turkish, have been mentioned?” Gürgey stressed that these scientists must be acknowledged for having recognized and for believing “that Turkish was adequate to communicate in all fields of science.” He paid special tribute to “Ord. Prof. Dr. Fritz Arndt"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn31",
      "id": "rch1fn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" [who] should not only be included among such scientists,... but also perhaps cited as the foremost of all.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn32",
      "id": "rch1fn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gürgey was Arndt’s student during the 1954-1955 academic year, the close of Arndt’s career in Turkey. He provides a dramatic picture of Arndt’s teaching. During Gürgey’s time, Arndt “used to give his lectures in an amphitheatre-shaped classroom which was later named for him. Attendance at lectures was not obligatory and attendance was not taken; however, the classroom used to fill up to the brim.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn33",
      "id": "rch1fn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" It is widely acclaimed by those who knew him that by the mid-1950s Arndt’s lectures were free of linguistic faults except intonation. In conversation his language was joyful, lively, humorous, and to the point. His written language had a structure which continuously took into account cause-outcome relationships. Arndt wrote in short sentences, free of ornamentation. They flowed meaningfully and were easy to understand. He did not shy away from creating words when necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is widely believed that Arndt invented the following Turkish words: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("çözücü,")]), _vm._v(" for solvent, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("çözelti")]), _vm._v(" for solution, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("çözünme")]), _vm._v(" for dissolution, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("çözünen")]), _vm._v(" for solute, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tarti")]), _vm._v(" for atomic weight, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("değerlik")]), _vm._v(" for valance, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aniklamak")]), _vm._v(" for to prepare, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("seyreltik")]), _vm._v(" for dilute, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("çökelti")]), _vm._v(" for precipitate, among others. Professor İsmet Gürgey recollects Arndt’s favorite play on words as a demonstration of the Master Teacher’s mastery of the Turkish language: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Elemente elaman diyen")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("elemandan el’aman")]), _vm._v("!” Arndt admonished “any student who says ‘elaman’ instead of ‘element’ will find himself immediately out of the classroom!” He was indeed famous for this play on three words which sound the same but have different meanings, namely: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("element")]), _vm._v(" = element, but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("elaman")]), _vm._v(" = personnel, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("el’aman")]), _vm._v(" = save me, or sick and tired of. The sentence may thus be translated as: “Sick and tired of the person who calls an element ’a person.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beyond any doubt, Fritz Arndt made major contributions to chemistry worldwide. His work on diazoketons resulted in what is still known as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arndt-Eistert")]), _vm._v(" reaction that made possible the creation of larger acids from their smaller homologues. He made major contributions to Turkish chemistry, and as has been shown, he also contributed to the development of scientific terminology in the Turkish language.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More broadly, the dynamism of the original three universities came from recognition by the Republic’s founding fathers of a need to educate future Turkish leaders in the ways of a “modern society” in “science,” and in the various dimensions of “enlightenment” as actually stated by Atatürk himself. This dynamism was accelerated by fallout from the sad political events taking place in lands northwest of Turkey. The result was a ferment of intellectual activity, spurred on by Turkey’s invitation of a select group of German, Austrian, and Czech academicians who were as indicated literally being discarded by their home institutions and ousted from their native countries. This ingathering created a developmental momentum in Turkey that continued generations after all of the foreigners had passed from the scene.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This momentum or diffusion process spawned many other state-supported as well as privately endowed universities within Turkey."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn34",
      "id": "rch1fn34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" In addition to the state universities whose development was sketched above, there was the venerable Robert College. It was the first Anglo-American institution in Turkey, and was founded in Istanbul in 1863 as a typical liberal arts college by American missionary and philanthropist Cyrus Hamlin. Engineering departments were added in 1912. Subsequently, the Robert College organization included a secondary school for boys and another one for girls. Among its graduates are leaders of Turkey’s academic, professional, and administrative cadres. Significantly, several sons and daughters of the émigré professors received their undergraduate degrees from Robert College. There are currently no fewer than 72 universities in Turkey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among these are at least six created by family groupings and endowed from personal wealth accumulated while creating national wealth within Turkey’s process of modernization and industrialization. These include Istanbul’s Koç and Sabanci universities. Ankara’s Bilkent University (the "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("oldest and most renowned) was established in 1983 with funding from private foundations controlled by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ihsan Doğramaci,")]), _vm._v(" MD. Doğramaci, a cosigner of the World Health Organization’s constitution (New York, July 1946), graduated from Istanbul University’s medical school in 1938."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn35",
      "id": "rch1fn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Thus, he is a direct product of a curriculum that, as will be shown, was greatly influenced and at the time, largely taught by the émigré professors. Among his many career honors is the fact that he served as President of the International Pediatric Association (1968-1977)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn36",
      "id": "rch1fn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other three universities endowed by businessmen, are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kadir Has Üniversitesi, İzzet Baysal Üniversitesi,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Istanbul Bilgi Üniversitesi.")]), _vm._v(" An e-mail message from Prof. Dr. Orhan N. Ulutin, “honorary member of the Turkish Academy of Science. and student of émigré professor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Erich Frank,”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1fn37",
      "id": "rch1fn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" states:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We now have 72 universities in Turkey. But we still look back to our golden age with German professors; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Frank, Winterstein, Schwarz, Cosswig, Heilbronn, Hirsch,")]), _vm._v(" and the rest. (emphasis added)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, these developments have indeed integrated western higher education into the fabric of a large and important segment of Turkish society while making its universities an integral part of higher education worldwide."), _c('a', {
    attrs: {
      "id": "page_32"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3db5703b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Chapter01.vue
// module id = 93
// module chunks = 0